<template>
    <v-container
        class="py-8 px-6"
        fill-height
        fluid
    >
        <v-row align="center" justify="center">
            <v-col class="ml-12 mr-12" style="min-width:850px; max-width:1000px;">
                <v-card class="rounded-xl pa-10" elevation="5">
                    <v-card-text>
                        <p class="text-center" style="font-size:25px; color:#000000;">
                            <span v-if="joinStep < 5" class="home-link" @click="goHome">
                                <v-icon class="home-icon">mdi-home-outline</v-icon>
                                <span class="home-text">홈으로 이동 ></span>
                            </span>
                            콜 Pro 서비스 회원 가입
                        </p>

                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-text v-if="joinStep < 5">
                        <stepper></stepper>
                    </v-card-text>
                    <v-card-text>
                        <router-view></router-view>
                    </v-card-text>
                </v-card>
                <br/>
                <main-footer></main-footer>
            </v-col>
        </v-row>
    </v-container>

</template>
<script>
import {mapGetters} from 'vuex'
import Stepper from '@/components/join/tile_stepper';
import MainFooter from '@/components/common/main_footer';

export default {
    name: 'join',
    components: {
        Stepper, MainFooter
    },
    data: () => ({}),
    computed: {
        ...mapGetters({
            joinStep: 'join/getJoinStep',
        }),
    },
    created() {
        this.$store.commit('layoutFlag', false)
        this.$store.commit('menuId', 'join')
    },
    mounted() {
    },
    methods: {
        goHome() {
            this.$router.push('/')
        }
    }
}
</script>
<style scoped>
.home-link {
    display: inline-flex;
    align-items: center;
    float: left;
    cursor: pointer;
    padding-top: 5px;
    height: 25px;
}

.home-icon {
    height: 20px;
}

.home-text {
    color: #555555;
    padding-left: 5px;
    font: normal normal bold 16px/25px 'Apple SD Gothic Neo', sans-serif;
}
</style>

